import React,{Component} from "react"
import { Button,message, Modal,notification, Form, Input, Icon, Spin } from "antd";
import ReactGA from 'react-ga';
import {CardElement,injectStripe} from  "react-stripe-elements";
import {CLOUD_FUNCTION} from "../../../../../config/fbConfig"
import Axios from 'axios';
const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'Notification',
      description: 'Congratulations! you have successfully added a new card ',
    });
  };
  class Addcard extends Component{
    constructor(props){
        super(props)
        this.state={
            isLoading:false,
            visible:false
        }
    }

    componentWillMount() {
      if(this.props.visible){
        this.setState({visible:this.props.visible})
      }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.auth.savedCardSuccess){
            openNotificationWithIcon('success')
            ReactGA.event({
              category: 'User',
              action: 'Add Card Info',
              label: 'User Interaction'
            });
            setTimeout(() => {
                window.location.reload();
            }, 1000);
            
        }
    }
    showModal = () => {
        this.setState({
          visible: true,
        });
      }
    
      handleOk = (e) => {
        this.setState({
          visible: false,
        });
      }
    
      handleCancel = (e) => {
        this.setState({
          visible: false,
        });
      }
      onChange=(e)=>{
        this.setState({[e.elementType]: e.complete})
    }
    
    handleSubmit=(e)=>{
        e.preventDefault();
        if(!this.state.card ) return message.error("Card not valid")
        this.props.form.validateFields((err, values) => {
          if (!err) {
        this.setState({isLoading:true})
            this.props.stripe.createToken({name:values.name,address_line1:values.billingAddr}).then(({token}) => {

                Axios.post(`${CLOUD_FUNCTION}/api/addCard`,{token,...values,customerId:this.props.profile.subscription.customerId})
                .then((res)=>{
                    console.log(res)
                    if(res.data.message){
                        window.fbq('track', 'AddPaymentInfo');
                        var  {card,customer} = res.data;
                        var userId =this.props.profile.uid;
                        if(this.props.profile.subscription.customerId){
                            this.props.saveCard(userId,card)
                        }else  this.props.saveCard(userId,card,customer.id)
                }else{
                    console.log(err)
                    message.error(res.data.err.message)
                    this.setState({error:res.data.error,isLoading:false,})
                }
                }).catch((err)=>{
                    console.log(err)
                    message.error("An error has occured. please try again later")
                    this.setState({isLoading:false,})
                })
            })
          }
        });
      }
    render(){
        var {profile} = this.props;
        const { getFieldDecorator } = this.props.form;
        return(
            <div className="add-card">
             {this.props.hideBtn ?null:<Button type="primary" onClick={this.showModal}>
            Add Card
        </Button>}
           
        <Modal
          title="Add Card"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          closable={false}
          className="card-modal"
        >
        <Spin spinning={this.state.isLoading} >
        <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item>
              <CardElement onChange={this.onChange}/>
            </Form.Item>
            <Form.Item>
            {getFieldDecorator('name', {
                rules: [{ required: true, message: 'Please input your card name!' }],
            })(
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Card holder name" />
            )}
            </Form.Item>
            <Form.Item>
            {getFieldDecorator('email', {
                rules: [{ required: true, message: 'Please input your billing address!' }],
            })(
                <Input prefix={<Icon type="red-envelope" style={{ color: 'rgba(0,0,0,.25)' }} />}  placeholder="Email address" />
            )}
            </Form.Item>
            <Form.Item>
            {getFieldDecorator('billingAddr', {
                rules: [{ required: true, message: 'Please input your billing address!' }],
            })(
                <Input prefix={<Icon type="home" style={{ color: 'rgba(0,0,0,.25)' }} />}  placeholder="Billing address" />
            )}
            </Form.Item>
        
          <Button type="submit" htmlType="submit" block >Save card</Button>
         </Form>
         </Spin>
        </Modal>
            </div>
        )
    }
}

const Wrapper = Form.create({ name: 'addCard' })(Addcard)
export default  injectStripe(Wrapper)